import "./modules/common";
import VueApp from "~/Scripts/new/vueApp";
import EmbeddedVideo from "~/Components/Common/EmbeddedVideo.vue";
import HeroCarousel from "~/Components/Base/HeroCarousel.vue";
import { navigation } from "~/Scripts/mixins/common";

new VueApp( {
  name: "Careers",
  mixins: [navigation],
  components: {
    EmbeddedVideo,
    HeroCarousel,
  },
} );
